import React from 'react';
import withProps from "recompose/withProps";
import filterObject, { shiftOfObject } from "@gqlapp/utils/filterObject";
import toPath from 'element-to-path';
import { getAttribute, getPos, getImage } from "@gqlapp/utils";

export function getStyle($options: any[], style:string){
	return shiftOfObject($options, function ($value: any, $key: string){
		return !!$value && [`${style}`, 'default'].includes($key);
	});
}

function getPoint([bw, bh ]: number[], [w, h]: number[], { x, y}: any){
	const [[], [maxX, minX, maxY, minY]]= getAttribute([bw, bh], w, h);
	x = getPos(x, minX, maxX);
	y = getPos(y, minY, maxY);
	return [bw * x/100 - w/2, bh * y/100 - h/2]
}


function fitImageInBounds([aw, ah]:number[], [bw, bh]: number[]) {
	const scaleWidth = bw / aw;
	const scaleHeight = bh / ah;

	const scale = Math.min(scaleWidth, scaleHeight);
	return [Math.round(aw * scale), Math.round(ah * scale), scale];
}

export function Svg(props: any){
	let { children, fontPath, background, icon, className } = props
	let { zoom, x, y } = background || {}; let { imgWidth, imgHeight}:any = icon || {};
	let  [{}, {}, qw, qh]:number[] = (props?.viewBox || ' ').split(' ');
	let keys = ['xmlns', 'viewBox'];

	if(!(x && y && zoom)){
		keys.push('className');
	}

	let svgProps = filterObject(props, (value: any, key: string)=> value && keys.includes(key));

	let Qrcode = (rest)=>(<svg {...svgProps} {...rest}>
		{(!!fontPath) && <defs>
			<style
				type="text/css"
				dangerouslySetInnerHTML={{ __html: `@import url('${fontPath}')`}}
			/>
		</defs>}
		{children}
	</svg>);

	if(!(x && y && zoom)){
		return <Qrcode />;
	}

	let { width: w, height:h , maxWidth, maxHeight, preview, mw, mh } = getImage(zoom, [1000, 1000], [qw, qh],[imgWidth, imgHeight]);
	let [ pointX, pointY ] = getPoint([ maxWidth, maxHeight ], [ w, h ], { x, y });
	let [width, height] = preview;

	let viewBox = [0, 0, width, height].join(' ');
	let wrapProps = { viewBox, className, width, height }

	return <svg xmlns="http://www.w3.org/2000/svg" {...wrapProps}>
		<image {...{ width, height}} xlinkHref={icon?.src} />
		<g transform={`translate(${pointX} ${pointY})`}>
			<Qrcode  width={mw /zoom} height={mh/zoom} />
		</g>
	</svg>
}


/**
 *
 * @param typeCallback
 * @param callback
 * @param options
 */
export default function optionCallback(typeCallback: string, callback: any, options?: any) {
	let path: string;
	if (options?.toPath) {
		path = toPath(options?.toPath);
	}
	return withProps((props: any) => {
		let frames = props?.frames || {}
		
		frames[typeCallback] = Object.assign(
			{name: typeCallback},
			{callback: (v: any) => callback({...v, Svg, path }), options: options || {}}
		)
		return {frames}
	});
}